export default "__VITE_ASSET__BFFTd1kB__"